/* PabDer — collection: filter rail + sort */
(function(){
  function init(){
    var btn=document.getElementById('filterBtn');
    var rail=document.getElementById('filterRail');
    var scrim=document.getElementById('filterScrim');
    var close=document.getElementById('filterClose');
    function open(){if(rail){rail.classList.add('open');scrim.classList.add('open');rail.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}}
    function shut(){if(rail){rail.classList.remove('open');scrim.classList.remove('open');rail.setAttribute('aria-hidden','true');document.body.style.overflow='';}}
    if(btn) btn.addEventListener('click',open);
    if(close) close.addEventListener('click',shut);
    if(scrim) scrim.addEventListener('click',shut);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')shut();});
    var sort=document.getElementById('colSort');
    if(sort) sort.addEventListener('change',function(){
      var u=new URL(window.location.href);
      u.searchParams.set('sort_by',sort.value);
      u.searchParams.delete('page');
      window.location.href=u.toString();
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
